const analyticsMiddleware = (_action) => {
    /*
     * Create switch statements similar to a reducer based on events triggered by the app
     * we want to track analytics for.
     */
};
export default analyticsMiddleware;
//# sourceMappingURL=analyticsMiddleware.js.map